import NavigationOnsiteAccordion from '@header/scripts/modules/header/navigation-onsite-accordion.js';
import JshModule from '@core/scripts/helper/jsh-module';

const {moduleScope, config} = JshModule('teaser/glossary-small-navi');
config.onsite = true;

handleHeaderListItem();
displayMobileNaviForFashionGlossary();

function displayMobileNaviForFashionGlossary() {
    NavigationOnsiteAccordion(moduleScope, config);
}

function handleHeaderListItem() {
    const headerListItem = moduleScope.querySelector('#onsite-navigation__item-header');
    const remainingListItems = moduleScope.querySelectorAll('[jsh-navigation__item]:not(#onsite-navigation__item-header)');
    // remove header list item if there are other list items
    if (remainingListItems.length > 0) {
        let orderedList = headerListItem.parentNode;
        orderedList.removeChild(headerListItem);
    }
}
